export default "assets/images/icons/arrow-gold-28a0beac.svg";